<template>
    <div class="join-rdct">
        <h2 v-if="urlNotFound">😕 Oops! No room or cast is linked with this shortcode</h2>
    </div>
</template>

<script>
import constants from '@/../constant.js';

export default {
    name: 'JoinRedirect',
    components: {
    },
    data() {
        return {
            urlNotFound: false,
        };
    },
    mounted() {
        this.redirectUrl();
    },
    methods: {
        async redirectUrl() {
            document.getElementById('loading-bg').style.display = 'block';
            const shortcode = this.$route.params.shortCode;
            const eventUrl = await this.fetchOriginalUrl(shortcode);
            if (eventUrl) {
                const url = new URL(eventUrl);
                const baseUrl = this.$globals.clientDomain; // your new base URL
                // Replace base URL while keeping path and query
                const newUrl = new URL(url.pathname + url.search + url.hash, baseUrl);
                window.location.href = newUrl.toString();
            } else {
                // this.$router.push("/");
                this.urlNotFound = true;
                this.$vs.notify({
                    title: 'Invalid shortcode',
                    text: 'Room/Cast not found for the given shortcode',
                    color: 'danger',
                });
            }
            document.getElementById('loading-bg').style.display = 'none';
        },

        async fetchOriginalUrl(shortcode) {
            try {
                const urls = [
                    `${constants.apiRoomUrl}/api/url/retrieve/${shortcode}/`,
                    `${constants.apiCastUrl}/api/url/retrieve/${shortcode}/`
                ];

                // Use allSettled to avoid failing if one request throws
                const results = await Promise.allSettled(urls.map(url => fetch(url)));

                // Extract valid responses
                for (const result of results) {
                    if (result.status === "fulfilled") {
                        try {
                            const data = await result.value.json();
                            if (data && data.original_url) {
                                return data.original_url;
                            }
                        } catch (e) {
                            // ignore invalid JSON
                        }
                    }
                }

                // If no valid url found
                return null;

            } catch (error) {
                console.error("Error fetching URLs:", error);
                return null;
            }
        }
    }
};
</script>

<style scoped>
* {
    font-family: 'JetBrains Mono', monospace !important;
}

.join-rdct {
    height: 100vh;
    width: 100vw;
    background-color: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.join-rdct h2 {
    color: #FFFFFF;
    margin: 0px 50px;
}
</style>